import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Fetch } from "../../shared/Fetch";
import { Checkbox } from "primereact/checkbox";
import { FrequencyTableTime } from "./FrequencyTableTime";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin, IPermissionProps } from "../../models/Login";


export interface IFrequencyTable {
    id?: number,
    company_Name?: string,
    branch_ID?: number,
    branchName?: string,
    frequency_Days?: string,
    updated_By?: string,
    updated_On?: Date,
}

export const FrequencyTable = (toast: any) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IFrequencyTable[], loading: boolean });
    const [openTimeModal, setOpenTimeModal] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IFrequencyTable });
    const dt = useRef<any>(null);

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const header = () => {
        return <p>Timesheet Email Sending Frequency Setting</p>;
    }

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const updateRow = async (updateData: IFrequencyTable) => {
        const response = await Fetch(`Timesheet/updateSendEmailFrequency`, "PUT", { id: updateData.id, branch_ID: updateData.branch_ID, frequency_Days: updateData.frequency_Days, updated_By: 0, updated_On: updateData.updated_On }, null, toast);
        if (response) {
            loadTableData();
            return true;
        } else return false;
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch(`Timesheet/getSendEmailFrequency`, "GET", null, null, toast);
        if (response) {
            const data: Array<IFrequencyTable> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'quantity':
            case 'frequency_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };

        let updateData: any = rowData;
        updateData.frequency_Days = newValue;
        if (await updateRow(updateData)) {
            setTableData(prev => {
                const updatedData = prev.tableData.map(item => {
                    if (item.id === rowData.id) {
                        return { ...item, frequency_Days: newValue };
                    }
                    return item;
                });
                return { ...prev, tableData: updatedData };
            })
        };
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };

        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', outline: 'none', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, []);

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", height: "67vh" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="60vh"
                value={tableData.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="company_Name" header="Company Name" />
                <Column field="branchName" header="Branch Name" />
                <Column field="frequency_Days" header="Frequency Days" style={{ minWidth: "18rem" }} body={(rowData: any) => {
                    return <div>
                        <div className="flex justify-content-center gap-2">
                            <div className="flex flex-column mr-1">
                                <label>All</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: "sun, mon, tue, wed, thu, fri, sat" });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: "" });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("sun") && (rowData?.frequency_Days || "").includes("mon") && (rowData?.frequency_Days || "").includes("tue") && (rowData?.frequency_Days || "").includes("wed") && (rowData?.frequency_Days || "").includes("thu") && (rowData?.frequency_Days || "").includes("fri") && (rowData?.frequency_Days || "").includes("sat")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Sun</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "sun") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", sun,")[0] + "," + (rowData.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("sun")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Mon</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "mon") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", mon,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("mon")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Tue</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "tue") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", tue,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("tue")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Wed</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "wed") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", wed,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("wed")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Thu</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "thu") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", thu,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("thu")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Fri</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "fri") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", fri,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("fri")}></Checkbox>
                            </div>
                            <div className="flex flex-column mr-1">
                                <label>Sat</label>
                                <Checkbox onChange={e => {
                                    if (e.checked === true) {
                                        updateRow({ ...rowData, frequency_Days: (rowData?.frequency_Days + ", " + "sat") });
                                    } else if (e.checked === false) {
                                        updateRow({ ...rowData, frequency_Days: ((rowData?.frequency_Days || "").split(", sat,")[0] + "," + (rowData?.frequency_Days || "").split(", mon,")[1]) });
                                    }
                                }} checked={(rowData?.frequency_Days || "").includes("sat")}></Checkbox>
                            </div>

                            {/* <Checkbox onChange={e => {
                                if (e.checked === true) {
                                    updateRow({ ...rowData, frequency_Days: (rowData.frequency_Days + ", " + "mon") });
                                } else if (e.checked === false) {
                                    updateRow({ ...rowData, frequency_Days: (rowData.frequency_Days.split(", mon,")[0] + "," + rowData.frequency_Days.split(", mon,")[1]) });
                                }
                            }} checked={rowData.frequency_Days.includes("mon")}></Checkbox> */}
                        </div>
                    </div>;
                }} />
                {/* <Column field="frequency_Days" header="Frequency Days" editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} /> */}
                <Column field="updated_By" header="Frequency Time" style={{ minWidth: "10rem" }} body={(rowData: any) => <div><p onClick={() => setOpenTimeModal({ open: true, singleData: rowData })} className="pi pi-clock cursor-pointer text-primary ml-8"></p></div>} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="updated_On" header="Updated On" body={updatedOn} /> */}
                <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, 'dd/MM/yyyy', DateFormat, true)} />
            </DataTable>
            <FrequencyTableTime open={openTimeModal.open} singleData={openTimeModal.singleData} hideDialog={() => setOpenTimeModal({ open: false, singleData: {} })} toast={toast} />
        </>
    );
}